import { useEffect, useState } from 'react';
import {
    getAuthenticateApiEndPointAddress,
    getAuthenticateReqOptions
} from '../utils/AuthenticationServiceUtils';

export const useAuthenticationService = (partnerUserData: any) => {
    const [authenticationData, setAuthenticationData] = useState(null);
    const [
        isFetchingAuthenticationService,
        setIsFetchingAuthenticationService
    ] = useState<boolean>(false);

    useEffect(() => {
        const fetchAuthenticationService = async () => {
            const shoudlMakeAuthenticateCall =
                partnerUserData?.nextAction === 'Authenticate';

            if (
                !partnerUserData?.providerCustomerId ||
                !shoudlMakeAuthenticateCall
            ) {
                setAuthenticationData(null);
                return;
            }
            const authenticateRequestConfig =
                getAuthenticateReqOptions(partnerUserData);

            try {
                setIsFetchingAuthenticationService(true);
                const response = await fetch(
                    getAuthenticateApiEndPointAddress(),
                    authenticateRequestConfig
                );

                if (response.ok) {
                    const authenticationServiceJsonData = await response.json();
                    setAuthenticationData(authenticationServiceJsonData);
                } else {
                    throw new Error(
                        `Error fetching Authentication service data: ${response.statusText}`
                    );
                }
            } catch (error) {
                console.log(error);
                setIsFetchingAuthenticationService(false);
            } finally {
                setIsFetchingAuthenticationService(false);
            }
        };

        fetchAuthenticationService();
    }, [partnerUserData?.providerCustomerId]);

    return { authenticationData, isFetchingAuthenticationService };
};
